/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OutputAllMenuPagesPermissionDto } from '../models/output-all-menu-pages-permission-dto';
import { OutputAllRolesDto } from '../models/output-all-roles-dto';
import { OutputAllUsersDto } from '../models/output-all-users-dto';
import { OutputRefreshTokenDto } from '../models/output-refresh-token-dto';
import { OutputSignInUserDto } from '../models/output-sign-in-user-dto';
import { userManagementCreateRolePost } from '../fn/user-management/user-management-create-role-post';
import { UserManagementCreateRolePost$Params } from '../fn/user-management/user-management-create-role-post';
import { userManagementCreateUserPost } from '../fn/user-management/user-management-create-user-post';
import { UserManagementCreateUserPost$Params } from '../fn/user-management/user-management-create-user-post';
import { userManagementDeleteRolePost } from '../fn/user-management/user-management-delete-role-post';
import { UserManagementDeleteRolePost$Params } from '../fn/user-management/user-management-delete-role-post';
import { userManagementDeleteRolePost$Plain } from '../fn/user-management/user-management-delete-role-post-plain';
import { UserManagementDeleteRolePost$Plain$Params } from '../fn/user-management/user-management-delete-role-post-plain';
import { userManagementDeleteUserPost } from '../fn/user-management/user-management-delete-user-post';
import { UserManagementDeleteUserPost$Params } from '../fn/user-management/user-management-delete-user-post';
import { userManagementGetAllRolesGet } from '../fn/user-management/user-management-get-all-roles-get';
import { UserManagementGetAllRolesGet$Params } from '../fn/user-management/user-management-get-all-roles-get';
import { userManagementGetAllRolesGet$Plain } from '../fn/user-management/user-management-get-all-roles-get-plain';
import { UserManagementGetAllRolesGet$Plain$Params } from '../fn/user-management/user-management-get-all-roles-get-plain';
import { userManagementGetAllUsersGet } from '../fn/user-management/user-management-get-all-users-get';
import { UserManagementGetAllUsersGet$Params } from '../fn/user-management/user-management-get-all-users-get';
import { userManagementGetAllUsersGet$Plain } from '../fn/user-management/user-management-get-all-users-get-plain';
import { UserManagementGetAllUsersGet$Plain$Params } from '../fn/user-management/user-management-get-all-users-get-plain';
import { userManagementGetMenusPagesPermissionByRoleIdGet } from '../fn/user-management/user-management-get-menus-pages-permission-by-role-id-get';
import { UserManagementGetMenusPagesPermissionByRoleIdGet$Params } from '../fn/user-management/user-management-get-menus-pages-permission-by-role-id-get';
import { userManagementGetMenusPagesPermissionByRoleIdGet$Plain } from '../fn/user-management/user-management-get-menus-pages-permission-by-role-id-get-plain';
import { UserManagementGetMenusPagesPermissionByRoleIdGet$Plain$Params } from '../fn/user-management/user-management-get-menus-pages-permission-by-role-id-get-plain';
import { userManagementGetMenusPagesPermissionsGet } from '../fn/user-management/user-management-get-menus-pages-permissions-get';
import { UserManagementGetMenusPagesPermissionsGet$Params } from '../fn/user-management/user-management-get-menus-pages-permissions-get';
import { userManagementGetMenusPagesPermissionsGet$Plain } from '../fn/user-management/user-management-get-menus-pages-permissions-get-plain';
import { UserManagementGetMenusPagesPermissionsGet$Plain$Params } from '../fn/user-management/user-management-get-menus-pages-permissions-get-plain';
import { userManagementSignInPost } from '../fn/user-management/user-management-sign-in-post';
import { UserManagementSignInPost$Params } from '../fn/user-management/user-management-sign-in-post';
import { userManagementSignInPost$Plain } from '../fn/user-management/user-management-sign-in-post-plain';
import { UserManagementSignInPost$Plain$Params } from '../fn/user-management/user-management-sign-in-post-plain';
import { userManagementTokenPost } from '../fn/user-management/user-management-token-post';
import { UserManagementTokenPost$Params } from '../fn/user-management/user-management-token-post';
import { userManagementTokenPost$Plain } from '../fn/user-management/user-management-token-post-plain';
import { UserManagementTokenPost$Plain$Params } from '../fn/user-management/user-management-token-post-plain';
import { userManagementUpdatePasswordPost } from '../fn/user-management/user-management-update-password-post';
import { UserManagementUpdatePasswordPost$Params } from '../fn/user-management/user-management-update-password-post';
import { userManagementUpdatePasswordPost$Plain } from '../fn/user-management/user-management-update-password-post-plain';
import { UserManagementUpdatePasswordPost$Plain$Params } from '../fn/user-management/user-management-update-password-post-plain';
import { userManagementUpdateRolePost } from '../fn/user-management/user-management-update-role-post';
import { UserManagementUpdateRolePost$Params } from '../fn/user-management/user-management-update-role-post';
import { userManagementUpdateRoleWithPermissionsPost } from '../fn/user-management/user-management-update-role-with-permissions-post';
import { UserManagementUpdateRoleWithPermissionsPost$Params } from '../fn/user-management/user-management-update-role-with-permissions-post';
import { userManagementUpdateUserPost } from '../fn/user-management/user-management-update-user-post';
import { UserManagementUpdateUserPost$Params } from '../fn/user-management/user-management-update-user-post';

@Injectable({ providedIn: 'root' })
export class UserManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userManagementSignInPost()` */
  static readonly UserManagementSignInPostPath = '/UserManagement/SignIn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementSignInPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementSignInPost$Plain$Response(
    params?: UserManagementSignInPost$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OutputSignInUserDto>> {
    return userManagementSignInPost$Plain(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementSignInPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementSignInPost$Plain(
    params?: UserManagementSignInPost$Plain$Params,
    context?: HttpContext
  ): Observable<OutputSignInUserDto> {
    return this.userManagementSignInPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputSignInUserDto>): OutputSignInUserDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementSignInPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementSignInPost$Response(
    params?: UserManagementSignInPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OutputSignInUserDto>> {
    return userManagementSignInPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementSignInPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementSignInPost(
    params?: UserManagementSignInPost$Params,
    context?: HttpContext
  ): Observable<OutputSignInUserDto> {
    return this.userManagementSignInPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputSignInUserDto>): OutputSignInUserDto => r.body)
    );
  }

  /** Path part for operation `userManagementTokenPost()` */
  static readonly UserManagementTokenPostPath = '/UserManagement/Token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementTokenPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementTokenPost$Plain$Response(
    params?: UserManagementTokenPost$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OutputRefreshTokenDto>> {
    return userManagementTokenPost$Plain(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementTokenPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementTokenPost$Plain(
    params?: UserManagementTokenPost$Plain$Params,
    context?: HttpContext
  ): Observable<OutputRefreshTokenDto> {
    return this.userManagementTokenPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputRefreshTokenDto>): OutputRefreshTokenDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementTokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementTokenPost$Response(
    params?: UserManagementTokenPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OutputRefreshTokenDto>> {
    return userManagementTokenPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementTokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementTokenPost(
    params?: UserManagementTokenPost$Params,
    context?: HttpContext
  ): Observable<OutputRefreshTokenDto> {
    return this.userManagementTokenPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputRefreshTokenDto>): OutputRefreshTokenDto => r.body)
    );
  }

  /** Path part for operation `userManagementGetAllUsersGet()` */
  static readonly UserManagementGetAllUsersGetPath = '/UserManagement/GetAllUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetAllUsersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllUsersGet$Plain$Response(
    params?: UserManagementGetAllUsersGet$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllUsersDto>>> {
    return userManagementGetAllUsersGet$Plain(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetAllUsersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllUsersGet$Plain(
    params?: UserManagementGetAllUsersGet$Plain$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllUsersDto>> {
    return this.userManagementGetAllUsersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputAllUsersDto>>): Array<OutputAllUsersDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetAllUsersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllUsersGet$Response(
    params?: UserManagementGetAllUsersGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllUsersDto>>> {
    return userManagementGetAllUsersGet(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetAllUsersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllUsersGet(
    params?: UserManagementGetAllUsersGet$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllUsersDto>> {
    return this.userManagementGetAllUsersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputAllUsersDto>>): Array<OutputAllUsersDto> => r.body)
    );
  }

  /** Path part for operation `userManagementCreateUserPost()` */
  static readonly UserManagementCreateUserPostPath = '/UserManagement/CreateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementCreateUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementCreateUserPost$Response(
    params?: UserManagementCreateUserPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementCreateUserPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementCreateUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementCreateUserPost(params?: UserManagementCreateUserPost$Params, context?: HttpContext): Observable<void> {
    return this.userManagementCreateUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementDeleteUserPost()` */
  static readonly UserManagementDeleteUserPostPath = '/UserManagement/DeleteUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementDeleteUserPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteUserPost$Response(
    params?: UserManagementDeleteUserPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementDeleteUserPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementDeleteUserPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteUserPost(params?: UserManagementDeleteUserPost$Params, context?: HttpContext): Observable<void> {
    return this.userManagementDeleteUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementUpdateUserPost()` */
  static readonly UserManagementUpdateUserPostPath = '/UserManagement/UpdateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementUpdateUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateUserPost$Response(
    params?: UserManagementUpdateUserPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementUpdateUserPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementUpdateUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateUserPost(params?: UserManagementUpdateUserPost$Params, context?: HttpContext): Observable<void> {
    return this.userManagementUpdateUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementGetMenusPagesPermissionByRoleIdGet()` */
  static readonly UserManagementGetMenusPagesPermissionByRoleIdGetPath =
    '/UserManagement/GetMenusPagesPermissionByRoleId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetMenusPagesPermissionByRoleIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionByRoleIdGet$Plain$Response(
    params?: UserManagementGetMenusPagesPermissionByRoleIdGet$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
    return userManagementGetMenusPagesPermissionByRoleIdGet$Plain(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetMenusPagesPermissionByRoleIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionByRoleIdGet$Plain(
    params?: UserManagementGetMenusPagesPermissionByRoleIdGet$Plain$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllMenuPagesPermissionDto>> {
    return this.userManagementGetMenusPagesPermissionByRoleIdGet$Plain$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>): Array<OutputAllMenuPagesPermissionDto> =>
          r.body
      )
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetMenusPagesPermissionByRoleIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionByRoleIdGet$Response(
    params?: UserManagementGetMenusPagesPermissionByRoleIdGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
    return userManagementGetMenusPagesPermissionByRoleIdGet(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetMenusPagesPermissionByRoleIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionByRoleIdGet(
    params?: UserManagementGetMenusPagesPermissionByRoleIdGet$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllMenuPagesPermissionDto>> {
    return this.userManagementGetMenusPagesPermissionByRoleIdGet$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>): Array<OutputAllMenuPagesPermissionDto> =>
          r.body
      )
    );
  }

  /** Path part for operation `userManagementGetMenusPagesPermissionsGet()` */
  static readonly UserManagementGetMenusPagesPermissionsGetPath = '/UserManagement/GetMenusPagesPermissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetMenusPagesPermissionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionsGet$Plain$Response(
    params?: UserManagementGetMenusPagesPermissionsGet$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
    return userManagementGetMenusPagesPermissionsGet$Plain(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetMenusPagesPermissionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionsGet$Plain(
    params?: UserManagementGetMenusPagesPermissionsGet$Plain$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllMenuPagesPermissionDto>> {
    return this.userManagementGetMenusPagesPermissionsGet$Plain$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>): Array<OutputAllMenuPagesPermissionDto> =>
          r.body
      )
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetMenusPagesPermissionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionsGet$Response(
    params?: UserManagementGetMenusPagesPermissionsGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
    return userManagementGetMenusPagesPermissionsGet(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetMenusPagesPermissionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetMenusPagesPermissionsGet(
    params?: UserManagementGetMenusPagesPermissionsGet$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllMenuPagesPermissionDto>> {
    return this.userManagementGetMenusPagesPermissionsGet$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>): Array<OutputAllMenuPagesPermissionDto> =>
          r.body
      )
    );
  }

  /** Path part for operation `userManagementGetAllRolesGet()` */
  static readonly UserManagementGetAllRolesGetPath = '/UserManagement/GetAllRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetAllRolesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllRolesGet$Plain$Response(
    params?: UserManagementGetAllRolesGet$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllRolesDto>>> {
    return userManagementGetAllRolesGet$Plain(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetAllRolesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllRolesGet$Plain(
    params?: UserManagementGetAllRolesGet$Plain$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllRolesDto>> {
    return this.userManagementGetAllRolesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputAllRolesDto>>): Array<OutputAllRolesDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementGetAllRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllRolesGet$Response(
    params?: UserManagementGetAllRolesGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<OutputAllRolesDto>>> {
    return userManagementGetAllRolesGet(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementGetAllRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementGetAllRolesGet(
    params?: UserManagementGetAllRolesGet$Params,
    context?: HttpContext
  ): Observable<Array<OutputAllRolesDto>> {
    return this.userManagementGetAllRolesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputAllRolesDto>>): Array<OutputAllRolesDto> => r.body)
    );
  }

  /** Path part for operation `userManagementCreateRolePost()` */
  static readonly UserManagementCreateRolePostPath = '/UserManagement/CreateRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementCreateRolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementCreateRolePost$Response(
    params?: UserManagementCreateRolePost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementCreateRolePost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementCreateRolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementCreateRolePost(params?: UserManagementCreateRolePost$Params, context?: HttpContext): Observable<void> {
    return this.userManagementCreateRolePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementDeleteRolePost()` */
  static readonly UserManagementDeleteRolePostPath = '/UserManagement/DeleteRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementDeleteRolePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteRolePost$Plain$Response(
    params?: UserManagementDeleteRolePost$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    return userManagementDeleteRolePost$Plain(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementDeleteRolePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteRolePost$Plain(
    params?: UserManagementDeleteRolePost$Plain$Params,
    context?: HttpContext
  ): Observable<boolean> {
    return this.userManagementDeleteRolePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementDeleteRolePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteRolePost$Response(
    params?: UserManagementDeleteRolePost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    return userManagementDeleteRolePost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementDeleteRolePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userManagementDeleteRolePost(
    params?: UserManagementDeleteRolePost$Params,
    context?: HttpContext
  ): Observable<boolean> {
    return this.userManagementDeleteRolePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userManagementUpdateRolePost()` */
  static readonly UserManagementUpdateRolePostPath = '/UserManagement/UpdateRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementUpdateRolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateRolePost$Response(
    params?: UserManagementUpdateRolePost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementUpdateRolePost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementUpdateRolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateRolePost(params?: UserManagementUpdateRolePost$Params, context?: HttpContext): Observable<void> {
    return this.userManagementUpdateRolePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementUpdateRoleWithPermissionsPost()` */
  static readonly UserManagementUpdateRoleWithPermissionsPostPath = '/UserManagement/UpdateRoleWithPermissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementUpdateRoleWithPermissionsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateRoleWithPermissionsPost$Response(
    params?: UserManagementUpdateRoleWithPermissionsPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return userManagementUpdateRoleWithPermissionsPost(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementUpdateRoleWithPermissionsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdateRoleWithPermissionsPost(
    params?: UserManagementUpdateRoleWithPermissionsPost$Params,
    context?: HttpContext
  ): Observable<void> {
    return this.userManagementUpdateRoleWithPermissionsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userManagementUpdatePasswordPost()` */
  static readonly UserManagementUpdatePasswordPostPath = '/UserManagement/UpdatePassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementUpdatePasswordPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdatePasswordPost$Plain$Response(
    params?: UserManagementUpdatePasswordPost$Plain$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    return userManagementUpdatePasswordPost$Plain(
      this.http,
      'https://ia-dev-dashboard-api.transflo.com',
      params,
      context
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementUpdatePasswordPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdatePasswordPost$Plain(
    params?: UserManagementUpdatePasswordPost$Plain$Params,
    context?: HttpContext
  ): Observable<boolean> {
    return this.userManagementUpdatePasswordPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userManagementUpdatePasswordPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdatePasswordPost$Response(
    params?: UserManagementUpdatePasswordPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    return userManagementUpdatePasswordPost(this.http, 'https://ia-dev-dashboard-api.transflo.com', params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userManagementUpdatePasswordPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userManagementUpdatePasswordPost(
    params?: UserManagementUpdatePasswordPost$Params,
    context?: HttpContext
  ): Observable<boolean> {
    return this.userManagementUpdatePasswordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }
}
